import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const ServicetypeService = {

  getAllServices: async () => {
    try {
      const response = await axios.get(ENDPOINT.services);
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  createServices: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.services, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  updateServices: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.services}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  deleteServices: async ( id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.services}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  // service type

  getAllServicesType: async () => {
    try {
      const response = await axios.get(ENDPOINT.serviceTypes);
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  getAllProductCat: async () => {
    try {
      const response = await axios.get(ENDPOINT.products_cat);
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  getAllProducts: async () => {
    try {
      const response = await axios.get(ENDPOINT.products);
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  getAllStatus: async () => {
    try {
      const response = await axios.get(ENDPOINT.eqstatus);
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  getAllCurrency: async () => {
    try {
      const response = await axios.get(ENDPOINT.eqcurrency);
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  getLastEq: async () => {
    try {
      const response = await axios.get(ENDPOINT.enquir_last);
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  createServicesType: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.serviceTypes, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  createProductCat: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.products_cat, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  createProducts: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.products, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  updateServicesType: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.serviceTypes}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },
  
  updateProductCat: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.products_cat}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },
  
  updateProducts: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.products}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  deleteServicesType: async ( id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.serviceTypes}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  deleteproductCat: async ( id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.products_cat}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  deleteProducts: async ( id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.products}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching services:", error.message);
      throw error;
    }
  },

  // vendors

   getAllVendors: async () => {
    try {
      const response = await axios.get(ENDPOINT.Vendors);
      return response.data;
    } catch (error) {
      console.error("Error fetching Vendors:", error.message);
      throw error;
    }
  },

  lastAddedPO: async () => {
    try {
      const response = await axios.get(ENDPOINT.lastAddedPO);
      return response.data;
    } catch (error) {
      console.error("Error fetching Vendors:", error.message);
      throw error;
    }
  },
  
  lastAddedBillId: async () => {
    try {
      const response = await axios.get(ENDPOINT.lastAddedBill);
      return response.data;
    } catch (error) {
      console.error("Error fetching Vendors:", error.message);
      throw error;
    }
  },

  createVendors: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.Vendors, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Vendors:", error.message);
      throw error;
    }
  },

  updateVendors: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.Vendors}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Vendors:", error.message);
      throw error;
    }
  },

  deleteVendors: async ( id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.Vendors}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Vendors:", error.message);
      throw error;
    }
  },
};
